import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { partners } from '../mockData';
import { Card, CardContent } from '../components/ui/card';

const Partners = () => {
  const { language } = useLanguage();
  const t = partners[language];

  // Mock partner logos with better styling
  const mockPartners = [
    { id: 1, name: 'Atlas Media Productions', logo: 'AMP' },
    { id: 2, name: 'Crescent Arts Foundation', logo: 'CAF' },
    { id: 3, name: 'Oasis Cultural Institute', logo: 'OCI' },
    { id: 4, name: 'Phoenix Film Studios', logo: 'PFS' },
    { id: 5, name: 'Desert Rose Entertainment', logo: 'DRE' },
    { id: 6, name: 'Zenith Writers Collective', logo: 'ZWC' },
    { id: 7, name: 'Mirage Media Group', logo: 'MMG' },
    { id: 8, name: 'Horizon Creative Labs', logo: 'HCL' }
  ];

  return (
    <div className="min-h-screen bg-page py-32">
      <div className="container mx-auto px-8">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-20 animate-fade-in">
          <h1 className="heading-1 text-gold mb-6">{t.title}</h1>
          <p className="body-large text-white/90">{t.subtitle}</p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {mockPartners.map((partner, index) => (
            <Card
              key={partner.id}
              className="bg-card-dark border-gold/20 hover:border-gold/50 transition-all duration-300 hover:transform hover:scale-105 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="p-8 flex items-center justify-center h-40">
                <div className="text-center w-full">
                  <div className="w-20 h-20 mx-auto mb-3 rounded-full bg-gold/10 flex items-center justify-center border-2 border-gold/30">
                    <span className="text-xl text-gold font-bold">{partner.logo}</span>
                  </div>
                  <p className="body-small text-gray-300 font-semibold">{partner.name}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA Section */}
        <div className="max-w-3xl mx-auto mt-20 text-center animate-fade-in" style={{ animationDelay: '0.6s' }}>
          <Card className="bg-card-dark border-gold/20">
            <CardContent className="p-12">
              <h2 className="heading-4 text-gold mb-4">
                {language === 'en' ? 'Become a Partner' : 'كن شريكًا'}
              </h2>
              <p className="body-medium text-gray-300 mb-6">
                {language === 'en'
                  ? 'Join us in celebrating exceptional storytelling and supporting emerging writers from around the world.'
                  : 'انضم إلينا في الاحتفاء بالحكايات الاستثنائية ودعم الكتّاب الناشئين من حول العالم.'}
              </p>
              <a
                href="mailto:partnerships@cairoscriptsfestival.com"
                className="inline-block px-8 py-3 bg-gold text-black font-semibold rounded-full hover:bg-gold/90 transition-colors"
              >
                {language === 'en' ? 'Contact Us' : 'اتصل بنا'}
              </a>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Partners;